import { fetchInviteStatus, type InviteStatusResult } from "@/lib/auth-api";

/**
 * Что показывать на странице регистрации (stage9-auth-redesign, Д3):
 * `checking` — левая колонка без формы, пока нет ответа; `invalid` — экран
 * «Ссылка недействительна»; `form` — форма.
 */
export type InviteView = "checking" | "invalid" | "form";

/**
 * Решение по ответу демона. Проверка — подсказка: `429` и сбой сети дают
 * форму, а окончательное слово за `410` на отправке; иначе поток мусорных
 * проверок запирал бы человека с живой ссылкой.
 */
export function viewForInviteStatus(status: InviteStatusResult): Exclude<InviteView, "checking"> {
  return status === "invalid" ? "invalid" : "form";
}

/**
 * Проверка ссылки при открытии страницы. Открытая регистрация (токена нет)
 * идёт без проверки и без запроса. Проверяющий — параметр: тест без сети.
 */
export async function resolveInviteView(
  token: string | null,
  check: (token: string) => Promise<InviteStatusResult> = fetchInviteStatus,
): Promise<Exclude<InviteView, "checking">> {
  if (token === null) {
    return "form";
  }
  return viewForInviteStatus(await check(token));
}
